import { CheckCircle, PenIcon } from "lucide-react";
import { FC } from "react";

interface StepperProps {
    steps: string[];
    step: number;
}
 
const Stepper: FC<StepperProps> = ({steps, step}) => {
    return (
      <ol className="flex items-center sm:w-full text-xs font-medium text-center text-[#00000080] sm:text-base mb-5 justify-center w-[90%] overflow-hidden break-words">
        {steps.map((s, i) =>
          i + 1 < steps.length ? (
            <li
              key={i}
              className={`${
                step > i + 1
                  ? "text-[#6F6AF8] after:border-text-[#6F6AF8]"
                  : "after:border-[#00000080]"
              } flex md:w-full items-center sm:after:content-[''] after:w-full after:h-1 after:border-b after:border-1 after:hidden sm:after:inline-block after:mx-1 sm:after:mx-6 xl:after:mx-10`}
            >
              <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-[#00000080] whitespace-nowrap">
                {step > i + 1 && <CheckCircle className="mr-1 sm:mr-2" />}
                {step === i + 1 && <PenIcon className="mr-1 sm:mr-2" />}
                {step < i + 1 && <span className="mr-1 sm:mr-2">{i + 1}</span>}
                {s}
              </span>
            </li>
          ) : (
            <li key={i} className="flex items-center whitespace-nowrap">
              {step > i + 1 && <CheckCircle className="mr-1 sm:mr-2" />}
              {step === i + 1 && <PenIcon className="mr-1 sm:mr-2" />}
              {step < i + 1 && <span className="mr-1 sm:mr-2">{i + 1}</span>}
              {s}
            </li>
          )
        )}
      </ol>
    );
}
 
export default Stepper;